import * as Scorm12Api from "./api12";
import {Manifest, ScoNavItem} from "../scorm/manifest";
import {ScormPluginBase} from "../scorm/plugin";
import {Manifest12} from "./manifest12";
import {Request, RequestCategory, SequencingProcess12} from "./sn";
import {NavActions} from "../scorm/sn";
import * as Message from "../message";

export {UrlVarService} from "../url";


export class Scorm12Plugin extends ScormPluginBase {
    public API: Scorm12Api.Scorm12Api = null;
    public sequencing: SequencingProcess12 = null;

    attemptSequencing(): string {
        if (this.nextScoAction) {
            return this.sequencing.do(new Request(RequestCategory.Navigation, this.nextScoAction, this.nextScoTarget));
        }
        return "";
    }

    createManifestClass(): Manifest {
        let man: Manifest;
        if (this.mvc.lastError != "") {
            return null;
        }

        if (this.mvc.schemaVersionMain == "1.2") {
            man = new Manifest12();
        }
        else {
            throw new Error("Manifest is for an unsupported SCORM version: " + this.mvc.schemaVersionMain);
        }
        man.schemaVersionMain = this.mvc.schemaVersionMain;
        man.schemaVersionSub = this.mvc.schemaVersionSub;
        man.rawManifest = this.mvc.rawManifest;
        return man;
    }

    initializeApi(scoNav: ScoNavItem) {
        if (this.manifest.schemaVersionMain === "1.2") {
            let i = this.scosData.scos[scoNav.identifier];
            i.set("cmi.core.student_id", this.config.studentId());
            i.set("cmi.core.student_name", this.config.studentName());
            if (this.config.launchDataAllowOverride(scoNav.identifier)) {
                i.set("cmi.launch_data", this.config.launchDataOverride(scoNav.identifier));
            } else {
                i.set("cmi.launch_data", scoNav.dataFromLms);
            }
            i.set("cmi.student_data.mastery_score", scoNav.masteryScore);
            i.set("cmi.student_data.max_time_allowed", scoNav.maxTimeAllowed);
            i.set("cmi.student_data.time_limit_action", scoNav.timeLimitAction);
            if (this.config.getCredit()) {
                i.set("cmi.core.credit", this.config.getCredit());
            }
            if (this.config.getMode()) {
                i.set("cmi.core.lesson_mode", this.config.getMode());
            }
            let comments = this.config.commentsFromLMS(scoNav.identifier);
            if (comments && comments.length > 0) {
                // @ts-ignore
                i.set("cmi.comments_from_lms", comments[0]["comment"]);
            }

            this.API = new Scorm12Api.Scorm12Api(scoNav.identifier, (<Scorm12Api.Sco12Data>this.scosData.scos[scoNav.identifier]), this.events, this.config);
            this.API.addSaveCallback(this.storage.save, this.storage);
            (<any>window).API = this.API;
            if (this.config.initializeScoAtOpen()) {
                this.API.LMSInitialize("");
            }
        }
        else {
            Message.show(this.config, Message.Error,"Manifest schema version unrecognized: " + this.manifest.schemaVersionMain);
        }
    }

    endPreviousSco() {
        // If there's anything already open, close it.
        // And don't re-end an already ended SCO.
        if (this.currentSco && this.API && !this.API.sco.end) {
            this.API.LMSFinish("");
        }
    }

    initializeScosData() {
        let i: number;
        // Now that we know the version, build the data structure that uses it.
        this.scosData = new Scorm12Api.AllScos12Data();
        for (i = 0; i < this.manifest.scoPreOrderTraversal.length; i++) {
            this.scosData.scos[this.manifest.scoPreOrderTraversal[i].identifier] = new Scorm12Api.Sco12Data();
        }
    }

    initializeSequencing() {
        this.nextScoAction = null;
        this.nextScoTarget = "";
        this.sequencing = new SequencingProcess12(this.manifest as Manifest12, this.scosData);

        // When attempting to return to last SCO on launch,
        // verify that the current SCO ID still exists in the version of the course that's trying to be loaded.
        // If it doesn't, we must fall through to a normal default launch.
        if (this.config.returnToLastActivityOnLaunch() && this.scosData.currentScoId && this.manifest.scosByIdentifiers[this.scosData.currentScoId]) {
            this.nextScoAction = NavActions.Choice;
            this.nextScoTarget = this.scosData.currentScoId;
        }
        else if (this.config.autoLaunchFirstSco()) {
            this.nextScoAction = NavActions.Start;
            this.nextScoTarget = "";
        }

        if (this.nextScoAction) {
            this.attemptNavigate();
        }
    }

    navigate(type: string) {
        if (type === "next") {
            this.nextScoAction = NavActions.Continue;
            this.nextScoTarget = "";
        }
        else if (type === "previous") {
            this.nextScoAction = NavActions.Previous;
            this.nextScoTarget = "";
        }
        else if (type === "repeat") {
            this.nextScoAction = NavActions.Choice;
            this.nextScoTarget = this.currentSco.identifier;
        }

        if (this.nextScoAction) {
            this.attemptNavigate();
        }
    }

    navigateByIdentifier(id: string) {
        this.nextScoAction = NavActions.Choice;
        this.nextScoTarget = id;
        this.attemptNavigate();
    }
}
